@if (formGroup) {
  <div class="container">
    <ng-template pdqHeaderContent>
      <div class="header">
        <pdq-button
          [disabled]="formGroup | disableSaveButton: pluginType : loadedConfig : formGroup.value"
          [loading]="saving"
          (onClick)="onSave()"
          variant="primary"
          >Save</pdq-button
        >
      </div></ng-template
    >
    <div class="grid-container">
      <div class="grid-container__left-col">
        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Configuration</pdq-heading>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <pdq-input
                label="Description text"
                [tooltip]="'Use {min_date} and {max_date} as placeholders for delivery date range'"
                [invalid]="!!formGroup.get('descriptionText').errors?.missingVariables"
                [invalidMsg]="formGroup.get('descriptionText').errors?.missingVariables"
                [formControl]="formGroup.get('descriptionText')"
                placeholder="Arrives between {min_date} - {max_date}">
              </pdq-input>
              <pdq-input
                label="Fallback text"
                [tooltip]="'Text to display when delivery dates are not available'"
                [formControl]="formGroup.get('fallbackText')"
                placeholder="Enter fallback text">
              </pdq-input>
            </div>
          </div>
        </pdq-card>

        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Display conditions</pdq-heading>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <div>Show the promise widget if all the following rules are met:</div>
              <product-page-conditions [formGroup]="formGroup.get('conditions')" [shop]="shop">
              </product-page-conditions>
            </div>
          </div>
        </pdq-card>
      </div>

      <div class="grid-container__right-col">
        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Test mode</pdq-heading>
              <pdq-slide-toggle [formControl]="formGroup.get('testMode')"></pdq-slide-toggle>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              Enable test mode to review your product page on your live shop while hiding it from your end customers
              @if (formGroup.get('testMode').value) {
                <div>
                  To test, add "?testProductPromise=1" to your product page URL. For example:
                  <div class="testmode-example">{{ testModeExample }}</div>
                </div>
              }
            </div>
          </div>
        </pdq-card>

        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Preview</pdq-heading>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <promise-ai-preview></promise-ai-preview>
            </div>
          </div>
        </pdq-card>

        <pdq-card variant="popover" color="white">
          <div class="card">
            <div class="card__header">
              <pdq-heading element="h5">Add widget to page</pdq-heading>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <pdq-heading element="h6">Activation Option 1: Theme block option</pdq-heading>
              <span class="text-with-link">
                Just drag and drop this block anywhere on the product page in your
                <pdq-link
                  label="theme editor."
                  [clickable]="themeEditorUrl"
                  [external]="true"
                  [url]="themeEditorUrl"
                  class="inline-link">
                </pdq-link>
                <div>*Requires theme upgrade to Online Store 2.0</div>
              </span>
              <pdq-link
                clickable="true"
                size="small"
                label="Detailed instructions"
                external="true"
                [url]="blockInstructionsUrl">
              </pdq-link>

              <pdq-heading element="h6" class="tag-code-header">Activation Option 2: Custom code</pdq-heading>
              @if (!(settings$ | async)?.pluginsScriptTagEnabled) {
                <div class="wran-message">
                  <img class="wran-message-icon" src="../../../../assets/icons/info-message-warn.svg" />
                  <div>
                    PDQ Features Script is disabled, please first
                    <pdq-link
                      label="enable it in your settings"
                      (onClick)="navigateToCheckoutSettings()"
                      class="inline-link">
                    </pdq-link>
                  </div>
                </div>
              }
              <div class="tag-code-text">
                <span>
                  Activate the PDQ Features Script.<br />
                  Then copy and paste the following tag into your product page.
                </span>
                <pdq-textarea [showCopyToClipboard]="true" [disabled]="true" [control]="tagCodeControl" rows="1">
                </pdq-textarea>
              </div>
              <pdq-link
                clickable="true"
                size="small"
                label="Detailed instructions"
                external="true"
                [url]="tagInstructionsUrl">
              </pdq-link>
            </div>
          </div>
        </pdq-card>
      </div>
    </div>
  </div>
}
